import { Component, Input, OnInit } from '@angular/core';
import { isString } from 'rev-shared/util';
import { IVideoSourceEvent } from './EditWebcast.Contract';
import { BsModalRef } from 'ngx-bootstrap/modal';

interface IResourceInfo {
	reservationDate: Date;
	isSelectedResource: boolean;
	videoSourceName: string;
	videoSourceDisplayName: string;
	events: IVideoSourceEvent[];
	isVideoSource: boolean;
	eventUrl: string;
}

@Component({
	selector: 'resource-schedule-dialog',
	templateUrl: './ResourceScheduleDialog.Component.html',
	standalone: false
})
export class ResourceScheduleDialogComponent implements OnInit {
	@Input() public resource: IResourceInfo;

	public reservationDate: Date;
	public isSelectedResource: boolean;
	public videoSourceName: string;
	public videoSourceDisplayName: string;
	public events: IVideoSourceEvent[];
	public isVideoSource: boolean;
	public eventUrl: string;

	public ngOnInit(): void {
		Object.assign(this, this.resource);
	}

	constructor(
		private readonly bsModalRef: BsModalRef
	) {}

	public close(): void {
		this.bsModalRef.hide();
	}

	public formatHostNames(hostNames: Array<{ firstName: string; lastName: string }>): string {
		return (hostNames || []).map(host => `${this.validateName(host.firstName)} ${this.validateName(host.lastName)}`.trim())
			.join(', ');
	}

	private validateName(name: string): string {
		return isString(name) ? name : '';
	}
}
